import Req from '../../$axios'

const serviceModule = {
  // 添加清单
  projectTemplatesIndex(params) {
    return Req(
      {
        url: '/projectTemplates/index',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  projectTemplatesDetail(params) {
    return Req(
      {
        url: '/projectTemplates/detail',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  projectTemplatesSave(params) {
    return Req(
      {
        url: '/projectTemplates/save',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  projectTemplatesSaveUpdate(params) {
    return Req(
      {
        url: '/projectTemplates/update',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  projectTemplatesSaveDelete(params) {
    return Req(
      {
        url: '/projectTemplates/delete',
        method: 'delete',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  }
}

export default {
  ...serviceModule
}
